import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'vuejs-noty/dist/vuejs-noty.css'
import * as localData from '@/services/localData.js'
import VueNoty from 'vuejs-noty'
import Vuelidate from 'vuelidate'
import "./registerServiceWorker"

// Testing user roles and login
// localData.setlocal('roles',JSON.stringify(['cargador','transitario','transportista']))
// localData.setlocal('auth_token',JSON.stringify('aadasdrsfsf42432s'))

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(Vuelidate)
Vue.use(VueNoty)

new Vue({
  beforeCreate () {
    Vue.prototype.$http = axios
    //axios.defaults.headers.common['Authorization'] = "Bearer  " + localData.getlocalToken('auth_token')
    //axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
    //axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    axios.defaults.xsrfHeaderName = 'X-CSRFToken'
    axios.defaults.xsrfCookieName = 'csrftoken' 
  },
  router,
  store,
  localData,
  render: h => h(App)
}).$mount('#app')




/* 
_account: "HJexeDXfII"
_device: "866039040845977"
_id: "n-3CIt2w_"
_rule: "ZWdutWwW7Hkx"
date: 1599132757320
data.props.sensor : "geofence"
data.type: "_out"
data.sensig.data: {
  alt: "115" 
  cog: "219" 
  gsm: "16"
  hdop: "2.1"​​
  loc: (2) […] ​​​
    0: "-1.096215"​​​​
    1: "37.724736" ​​​
  length: 2​​​​​
  sats: "12"
  sog: "0"
  time: "1599132755"
  vb: "4019"
  vi: "4189"
  vs: "4585"
} 
*/


const auth_token = localData.getlocalToken('auth_token')
if (auth_token) {
  localData.setlocalToken('auth_token',auth_token)
}

